import React from "react";
import { Page, NavItem, TabPane } from "components/common";
import { compose } from "recompose";
import { Nav, TabContent } from "reactstrap";
import { Redirect, Switch } from "react-router-dom";
import CurrentClaim from "./CurrentClaim";
import AwaitingAuthorisation from "./AwaitingAuthorisation";
import AwaitingPayment from "./AwaitingPayment";

export const List = ({ match, xero }) => (
  <Page title="Expense Claims">
    <div>
      <Nav tabs>
        <NavItem to={`${match.url}/current`}>Current Claim</NavItem>
        <div className="mx-auto" />
        <NavItem to={`${match.url}/awaiting_authorisation`}>
          Awaiting Authorisation
        </NavItem>
        <NavItem to={`${match.url}/awaiting_payment`}>Awaiting Payment</NavItem>
      </Nav>
      <TabContent>
        <Switch>
          <TabPane path={`${match.url}/current`} component={CurrentClaim} />
          <TabPane
            path={`${match.url}/awaiting_authorisation`}
            component={AwaitingAuthorisation}
          />
          <TabPane
            path={`${match.url}/awaiting_payment`}
            component={AwaitingPayment}
          />
          <Redirect to={`${match.url}/current`} />
        </Switch>
      </TabContent>
    </div>
  </Page>
);

export const enhance = compose();

export default enhance(List);
